// extracted by mini-css-extract-plugin
export default {"content":"src-views-analytics-containers-RevenueView-RevenueView__content--KEkOn","mainContent":"src-views-analytics-containers-RevenueView-RevenueView__mainContent--xcWj8"};